export class AlterarSobraDTO {
  transferenciaId: number;
  postoId: number;
  contratoId: number;
  parcelaId: number;
}
